export default {
  "Cards": "_Cards_o0aig_1",
  "Title": "_Title_o0aig_12"
};import "ni:sha-256;xpNmznBGb___jPva6LxOuAMMUg7tq7OvamdP98xeiBs";